module.exports = __webpack_public_path__ + "img/xrp-2020-quarter-1.fc22bd81.png";